// JavaScript Document
//components/signs/sign.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import ButtonBase from '@material-ui/core/ButtonBase';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
//import Map from './Map';
//import Map from '../../map/Map';
//import SingleMap from '../../map/SingleMap';
//import SaveIcon from '@material-ui/icons/Save';
//import ImagePicker from './ImagePicker';
//import Option from '../option/View';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
	//backgroundColor: theme.palette.background.paper
  },
	formCard : {
		marginBottom: theme.spacing(3),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
  paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
  signTypeItem : {
	  backgroundSize:'contain', 
	  backgroundRepeat:'no-repeat', 
	  backgroundPosition:'center',	
	  textAlign:'center',
  },

}));




export default function SignBasic(props) {
	const classes = useStyles();
	const {sign, onChange} = props;
	const [signId, setSignId] = React.useState(0);
	//const [loaded, setLoaded] = React.useState(false);
	//const [types, setTypes] = React.useState([]);
	//const [changed, setChanged] = React.useState(false);
	//const [saveLabel, setSaveLabel] = React.useState('Save');
	const auvars = ['test_com', 'update_time', 'load_pri', 'auto_update'];
	const [aud, setAud] = React.useState({
		update_time: '12:00',
		test_com : 0,
		load_pri : 1,
		auto_update : 1
	});
	React.useEffect(() => {
		if(sign && parseInt(sign.id) !== signId){
			setSignId(parseInt(sign.id));
			var bds = {};
			for(let bd of auvars){
				bds[bd] = sign[bd];
			}
			//auvars.forEach((bd) => bds[bd] = sign[bd]);
			//if(!bds.max_spl_speed)
			//	bds.max_spl_speed = 0;
			setAud(bds);
		}
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	
	//handle change any value
	const handleChangeValue = (e) => {
		let name = e.target.name;
		let value = e.target.value
		let newDetails = Object.assign({}, aud);
		
		//if numeric
		
		if(name === 'update_time'){
			//do nothing?
		} else {
			value = e.target.checked ? 1 : 0;
		}
		
		newDetails[name] = value;
		setAud(newDetails);
		if(onChange){
			console.log('something changed!');
			onChange(newDetails);
		}
		//setChanged(true);
	}
	const renderForm = () => {
		if(aud.auto_update)
			return (
				<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6}>
						<FormControlLabel
          					control={<Switch checked={Boolean(aud.load_pri)} onChange={handleChangeValue} name="load_pri" />}
          					label={aud.load_pri ? "Upload configuration": "No configuration update"}
        				/>
						<FormControlLabel
          					control={<Switch checked={Boolean(aud.test_com)} onChange={handleChangeValue} name="test_com" />}
          					label={aud.test_com ? "Test communication": "Communication test disabled"}
        				/>	
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							id="sign_update_time"
							name="update_time"
							label="Target daily update time"
							type="time"
							value={aud.update_time}
							onChange={handleChangeValue}
							inputProps={{step: 300}}
							fullWidth
						/>
					</Grid>
				</Grid>
	  		</CardContent>
			);
		return '';
	}
	
	
	return (
		<Card className={classes.root}>
			<CardHeader title="Automatic updates" action={<FormControlLabel control={<Switch checked={Boolean(aud.auto_update)} onChange={handleChangeValue} name="auto_update" />} label={aud.auto_update ? 'Enabled' : 'Disabled'} />} />
			{renderForm()}
	  	</Card>
	);
}
